import { createContext, ReactNode, useContext } from 'react';
import { GrfqTrade, GrfqTradeTape } from '#/unified-rfqs/entities/grfq/domain';

const Context = createContext<GrfqTradeTape | GrfqTrade | null>(null);
Context.displayName = 'GrfqTradeProvider';

interface Props {
  readonly children: ReactNode;
  readonly trade: GrfqTradeTape | GrfqTrade;
}

export function GrfqTradeProvider(props: Props) {
  const { children, trade } = props;
  return <Context.Provider value={trade}>{children}</Context.Provider>;
}

export function useGrfqTrade() {
  const ctx = useContext(Context);
  if (ctx == null) {
    throw new Error('Missing GrfqTradeProvider upwards in this tree');
  }
  return ctx;
}
